
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire629d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire629d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $hEy27 = parcelRequire("hEy27");
parcelRequire("2T347");

var $bAHo9 = parcelRequire("bAHo9");
// expose methods to set/get device ID inside iframe
(0, (/*@__PURE__*/$parcel$interopDefault($hEy27))).connectToParent({
    methods: {
        async getDeviceIdIframeLocalStorage () {
            try {
                return localStorage.getItem((0, $bAHo9.deviceIdKey)) || "";
            } catch (error) {
                return "";
            }
        },
        async setDeviceIdIframeLocalStorage (id) {
            try {
                localStorage.setItem((0, $bAHo9.deviceIdKey), id);
                return id;
            } catch (error) {
                return "";
            }
        }
    }
});


//# sourceMappingURL=index.b01cceab.js.map
